module.exports = __webpack_public_path__ + "static/img/ko.2473d861.png";